import { FlickOColors } from "./color";

import { StyleSheet, Dimensions } from "react-native";
import { getResponsiveSize } from "./globalStyles";

const { width } = Dimensions.get("window");
export const styles = StyleSheet.create({
  errorText: {
    color: "#FF3B30",
    fontSize: getResponsiveSize(12),
    marginLeft: getResponsiveSize(4),
    marginBottom: getResponsiveSize(8),
    fontWeight: "400",
  },
  container: {
    flex: 1,
    backgroundColor: FlickOColors.white,
  },
  mainContainer: {
    flex: 1,
    maxWidth: 480,
    width: "100%",
    alignSelf: "center",
  },
  scrollContainer: {
    flexGrow: 1,
  },
  contentContainer: {
    padding: getResponsiveSize(24),
    flex: 1,
  },
  title: {
    fontSize: getResponsiveSize(24),
    fontWeight: "bold",
    color: FlickOColors.text.primary,
    textAlign: "center",
    marginBottom: getResponsiveSize(8),
  },
  dividerContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: getResponsiveSize(32),
    marginBottom: getResponsiveSize(32),
  },
  divider: {
    flex: 1,
    height: getResponsiveSize(1),
    backgroundColor: FlickOColors.gray.light,
  },
  subtitle: {
    fontSize: getResponsiveSize(16),
    color: FlickOColors.text.secondary,
    fontWeight: "bold",
    marginHorizontal: getResponsiveSize(12),
  },
  formContainer: {
    width: "100%",
    gap: getResponsiveSize(16),
  },
  input: {
    width: "100%",
    backgroundColor: FlickOColors.white,
    borderWidth: 1,
    borderColor: FlickOColors.gray.lighter,
    borderRadius: getResponsiveSize(8),
    paddingHorizontal:
      width > 768 ? getResponsiveSize(12) : getResponsiveSize(8),
    fontSize: width > 768 ? getResponsiveSize(16) : getResponsiveSize(14),
    color: FlickOColors.gray.dark,
    height: width > 768 ? getResponsiveSize(48) : getResponsiveSize(44), // Changed minHeight to height
    textAlignVertical: "center",
    includeFontPadding: false, // Changed to false
    textAlign: "left",
    padding: 0, // Remove default padding
  },
  inputFocused: {
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 3,
  },
  passwordContainer: {
    position: "relative",
    width: "100%",
  },
  eyeIcon: {
    position: "absolute",
    right: getResponsiveSize(12),
    top: "50%",
    transform: [{ translateY: -12 }],
  },
  submitButton: {
    backgroundColor: FlickOColors.primary,
    paddingVertical: getResponsiveSize(16),
    borderRadius: getResponsiveSize(12),
    marginTop: getResponsiveSize(8),
  },
  submitButtonText: {
    color: FlickOColors.white,
    fontSize: getResponsiveSize(16),
    fontWeight: "600",
    textAlign: "center",
  },
  toggleButton: {
    paddingVertical: getResponsiveSize(12),
  },
  toggleButtonText: {
    color: FlickOColors.primary,
    fontSize: getResponsiveSize(14),
    textAlign: "center",
  },
  termsText: {
    color: FlickOColors.text.secondary,
    fontSize: getResponsiveSize(12),
    textAlign: "center",
    lineHeight: getResponsiveSize(18),
    marginTop: getResponsiveSize(16),
  },
  disabledButton: {
    opacity: 0.6,
  },
});
